export default __webpack_public_path__ + "static/media/logoInteract.7902871b.png";